module.exports = __webpack_public_path__ + "media/images/guaranteed-guest-list-access-e2fc13b4652e8f60b9bddccbdfd97c1f.svg";